import React from 'react';
const Button = () => {
  return <a href="https://veiramode.com/products/nie-zapomnij-o-sobie-ebook" target="_blank" rel="noopener noreferrer" className="inline-block bg-orange-500 hover:bg-orange-600 text-white font-bold py-4 px-8 rounded-lg shadow-lg text-xl transition-all transform hover:scale-105 focus:outline-none focus:ring-4 focus:ring-orange-300" data-id="element-10">
      SPRAWDŹ DOSTĘPNOŚĆ E-BOOKA "NIE ZAPOMNIJ O SOBIE" →
    </a>;
};
export default Button;